module.exports = __webpack_public_path__ + "static/media/om_beard_shortboxed_long__square.c548687f.png";